(() => {
  'use strict';
  if (window.CoucheryCloudsoftDetails) return;
  const label = document.currentScript.dataset.label;
  const hosts = new WeakSet();
  const isSquare = source => /cloudsoft-weave-.*-square-swatch\./i.test(source || '');
  const start = host => {
    if (hosts.has(host)) return;
    hosts.add(host);
    let queued = false;
    const refresh = () => {
      queued = false;
      const selected = host.current?.material === 'Cloudsoft Weave';
      host.classList.toggle('cch-cloudsoft-selected', selected);
      host.querySelectorAll('figure.lf-loft-swatch, figure.sr-actual').forEach(figure => {
        const photo = figure.querySelector('img');
        const caption = figure.querySelector('figcaption small') || figure.querySelector('figcaption');
        if (!photo || !caption) return;
        if (!caption.hasAttribute('data-cch-original-label')) caption.dataset.cchOriginalLabel = caption.textContent;
        const preview = isSquare(photo.getAttribute('src'));
        figure.classList.toggle('cch-cloudsoft-detail', preview);
        const text = preview ? label : caption.dataset.cchOriginalLabel;
        if (caption.textContent !== text) caption.textContent = text;
        if (preview) {
          const alt = photo.alt.replace(/^Actual\s+/i, '').replace(/(?:original material photograph|fabric photograph)$/i, label);
          if (alt !== photo.alt) photo.alt = alt;
          if (figure.getAttribute('aria-label')?.startsWith('Actual')) figure.setAttribute('aria-label', label);
        }
      });
    };
    const schedule = () => {
      if (queued) return;
      queued = true;
      queueMicrotask(refresh);
    };
    new MutationObserver(schedule).observe(host, {subtree:true,childList:true,attributes:true,attributeFilter:['src','open','aria-pressed','hidden']});
    refresh();
  };
  const boot = root => root.querySelectorAll('couchery-product-configurator').forEach(start);
  window.CoucheryCloudsoftDetails = Object.freeze({boot});
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => boot(document), {once:true});
  else boot(document);
  document.addEventListener('shopify:section:load', event => boot(event.target));
})();
